module.exports = function getResource(label, vars = []) {
    let resources = {
        zeroResult: 'Désolé, nous n’avons pas trouvé de résultats.',
        updateFilter: 'Essayer de changer ou de supprimer vos filtres.'
    };

    return resources[label];
};
